export const countryCodes = [
  { value: '+973', label: 'BH +973', placeholder: '36xx-xxxx' },
  { value: '+965', label: 'KW +965', placeholder: '5xxx-xxxx' },
  { value: '+966', label: 'SA +966', placeholder: '50-xxx-xxxx' },
  { value: '+971', label: 'AE +971', placeholder: '50-xxx-xxxx' },
  { value: '+968', label: 'OM +968', placeholder: 'xxx-xxxx' },
  { value: '+964', label: 'IQ +964', placeholder: '790-xxx-xxxx' },
  { value: '+249', label: 'SD +249', placeholder: '90-xxx-xxxx' },
  { value: '+20', label: 'EG +20', placeholder: '10-xxx-xxxx' },
  { value: '+962', label: 'JO +962', placeholder: '77-xxx-xxxx' },
];
